export default {
  'VIDEO_CATEGORY' (state) {
    return state.category
  },
  'VIDEO_CATEGORIES' (state) {
    return state.categories
  }
}
